import React from "react";
import "../styles/packagesHero.scss";

function packagesHero() {
  return (
    <div className="container-outer packages-hero-bg">
      <div className="container-full packages-hero">
        <h1>Choose & customize your package</h1>
      </div>
    </div>
  );
}

export default packagesHero;
